"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var elog = require("../../elog");
var bind_1 = require("../../bind");
var core_link_1 = require("../../components/core_link");
var react_tracking_1 = require("react-tracking");
var tracker_1 = require("../../tracker");
var COMPONENT_NAME = 'LinkList';
var LinkList = /** @class */ (function (_super) {
    tslib_1.__extends(LinkList, _super);
    function LinkList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LinkList.prototype.renderLink = function (link, idx) {
        var classes = classNames('link-list__item', { 'link-list__item--parent': link.isParent });
        return (React.createElement("li", { key: "" + idx, className: classes },
            React.createElement(core_link_1.default, { to: link.url }, link.text)));
    };
    LinkList.prototype.renderBackLink = function () {
        if (!this.props.backLinkText || !this.props.backLinkUrl)
            return null;
        return (React.createElement("li", { className: "link-list__item link-list__item--back", id: this.props.jumplinkSlug || null },
            React.createElement(core_link_1.default, { to: this.props.backLinkUrl }, this.props.backLinkText)));
    };
    LinkList.prototype.render = function () {
        if (!this.props.links)
            return null;
        try {
            return (React.createElement("nav", { className: "link-list" },
                this.props.title &&
                    React.createElement("h2", { className: "link-list__title" }, this.props.title),
                this.renderBackLink(),
                React.createElement("ul", null, this.props.links.map(this.renderLink))));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    tslib_1.__decorate([
        bind_1.default
    ], LinkList.prototype, "renderLink", null);
    LinkList = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                componentName: COMPONENT_NAME,
                eventType: tracker_1.VIEW,
                context: {
                    layoutSection: props.layoutSection,
                    pagePosition: props.pagePosition,
                },
            };
        }, { dispatchOnMount: true })
    ], LinkList);
    return LinkList;
}(React.Component));
exports.default = LinkList;
//# sourceMappingURL=link_list.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/link_list.js
// module id = rB9C
// module chunks = 0 2 6 20